import {
  GraduationCap,
  Trophy,
  HeartPulse,
  Users,
  Lightbulb,
  ShieldCheck,
  Lock,
  CreditCard,
  EyeOff,
} from "lucide-react";
import { Reveal } from "./Reveal";

export const ICONS = {
  GraduationCap,
  Trophy,
  HeartPulse,
  Users,
  Lightbulb,
  ShieldCheck,
  Lock,
  CreditCard,
  EyeOff,
};

export function Icon({ name, className = "h-6 w-6" }) {
  const Cmp = ICONS[name] || Lightbulb;
  return <Cmp className={className} />;
}

export function Overline({ children, className = "" }) {
  return (
    <span className={`overline inline-flex items-center gap-2 text-gold ${className}`}>
      {children}
    </span>
  );
}

export function PageHero({ label, title, accent, subtitle }) {
  return (
    <section className="relative overflow-hidden brand-ink text-white pt-32 md:pt-36">
      <div className="grain absolute inset-0 opacity-30" />
      <div className="pointer-events-none absolute -right-24 top-6 h-72 w-72 rounded-full bg-[#c8892b]/15 blur-3xl" />
      <div className="relative mx-auto max-w-[1400px] px-5 pb-16 md:px-8 md:pb-24">
        <Reveal immediate>
          <span className="overline inline-flex items-center gap-2 txt-gold">
            {label}
          </span>
        </Reveal>
        <Reveal immediate delay={0.08}>
          <h1 className="mt-6 max-w-4xl font-heading text-4xl font-bold leading-[1.02] tracking-tight sm:text-5xl lg:text-6xl">
            {title} {accent && <span className="font-script text-5xl font-bold lg:text-6xl txt-gold">{accent}</span>}
          </h1>
        </Reveal>
        {subtitle && (
          <Reveal immediate delay={0.16}>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-white/75 md:text-lg">{subtitle}</p>
          </Reveal>
        )}
      </div>
      <div className="relative -mt-1 w-full leading-[0]">
        <svg viewBox="0 0 1440 100" preserveAspectRatio="none" className="block h-[54px] w-full md:h-[84px]">
          <path d="M0,50 C360,100 720,4 1080,30 C1260,44 1380,66 1440,58 L1440,100 L0,100 Z" fill="hsl(var(--background))" />
          <path d="M0,42 C360,92 720,-4 1080,22 C1260,36 1380,58 1440,50" fill="none" stroke="#c8892b" strokeWidth="3" />
        </svg>
      </div>
    </section>
  );
}
